export enum DELIVERY_TYPE {
  CHANGE = 'CHANGE',
  MOVE = 'MOVE',
  ADD_CONSUMPTION_POINT = 'ADD_CONSUMPTION_POINT'
}
